import { contactNumbers } from '@adc/constants'
import { PhoneVerification } from '@adc/ui-core'

export const genericErrorTitle = 'Sorry, an error occurred'
export const genericErrorMessage = `It seems we've encountered a hiccup. Give it another shot in a few moments. Make sure your internet connection is stable. If the issue persists, don't hesitate to reach out to our support team at ${PhoneVerification.utils.formatPhoneNumber(
  contactNumbers.ONLINE_BUYER_EXPERIENCE.toString()
)}.`
